import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20modern%20home%20theater%20interior%20with%20large%20projection%20screen%2C%20comfortable%20seating%2C%20soft%20ambient%20lighting%20in%20warm%20amber%20and%20cream%20tones%2C%20abstract%20geometric%20wall%20art%2C%20luxurious%20yet%20cozy%20atmosphere%2C%20cinematic%20mood%2C%20high%20quality%20interior%20photography&width=1800&height=1200&seq=hero-bg-2026&orientation=landscape"
        alt="麻豆在线官方正版内容平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
          麻豆在线
        </h1>
        <p className="text-lg md:text-xl text-background-50/90 mb-3 font-light">
          官方正版高清影视内容平台
        </p>
        <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto mb-8 leading-relaxed">
          海量优质资源随时在线畅享，汇聚最新资讯、内容导航与会员服务，安全稳定，极速加载
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/yingshi-tuijian"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
          >
            立即体验
          </Link>
          <Link
            to="/category/huiyuan-zhuanxiang"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-base font-semibold hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
          >
            了解会员
          </Link>
        </div>
      </div>
    </section>
  );
}